import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  title: {
    fontFamily: "Manrope",
    fontSize: "18px",
    fontWeight: 700,
    color: "#465869",
    lineHeight: "18px",
  },
  infoModal: {
    width: "45vw",
  },
  button: {
    marginRight: "10px",
  },

  icon: {
    fontSize: "16px",
    marginLeft: "5px",
  },

  formContent: {
    margin: 0,
  },

  deleteContactIconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: "-25px",
  },

  addAnotherContact: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    cursor: "pointer",
  },

  statusContent: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: 20,
    right: 16,
  },

  textStatus: {
    color: "#465869",
    fontSize: "12px",
    fontWeight: 700,
  },

  customBadge: {
    textTransform: "uppercase",
  },

  loading: {
    position: "absolute",
    top: "0",
    left: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    background: "#FFF",
    zIndex: 1000,
  },
  subtitle: {
    display: "block",
    fontFamily: "Manrope",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: 0.4,
    color: colors.gray500,
    marginTop: 4,
  },
}));

export default styles;
